<template>
  <div>
    <hshead title="我的订单" bgcolor="#fff"></hshead>
    <van-tabs v-model="active" swipeable  title-active-color="#007dfa" color="#007dfa">
      <van-tab title="全部">
        <div class="order-ul">
          <van-list v-model="loading" :finished="finished" finished-text="没有更多了" @load="onLoad">
            <div class="order-li" v-for="(item, index) in list" :key="index">
              <div class="top-p">
                <div class="top-l">订单编号：11977240</div>
                <div class="top-r">待拍摄</div>
              </div>
              <div class="content-box">
                <div class="content-top">
                  <div class="left-img">
                    <img src="../assets/images/order/icon.png" alt />
                  </div>
                  <div class="center-p">
                    <div class="center-p-h1">去拍拍自营店</div>
                    <div class="center-p-p">1天前</div>
                  </div>
                  <div class="right-icon">
                    <img src="../assets/images/order/ellipsis.png" alt />
                  </div>
                </div>
                <div class="content-content">
                  <div class="left-p">
                    高级套餐
                    <span>(30张)</span>
                  </div>
                  <div class="right-p">¥800.00</div>
                </div>
                <div class="content-iconp iconp1">广州市天河区WWWWW酒店</div>
                <div class="content-iconp iconp2">广州市天河区黄埔大道30号</div>
                <div class="content-iconp iconp3">2019.05.01－2019.05.05</div>
              </div>
              <div class="order-li-bt">
                <a href class="this-btn btn1">取消订单</a>
                <a href class="this-btn btn2">预约时间</a>
              </div>
            </div>
          </van-list>
        </div>
      </van-tab>
      <van-tab title="待拍摄">内容 2</van-tab>
      <van-tab title="待审核">内容 2</van-tab>
      <van-tab title="已完成">内容 2</van-tab>
      <van-tab title="打回">内容 2</van-tab>
    </van-tabs>
  </div>
</template>

<script>
import hshead from "@/components/common/hshead";
import { Tab, Tabs, List } from "vant";
export default {
  name: "order",
  data() {
    return {
      active: 0,
      list: [],
      loading: false,
      finished: false
    };
  },
  methods: {
    onLoad() {
      // 异步更新数据
      setTimeout(() => {
        for (let i = 0; i < 10; i++) {
          this.list.push(this.list.length + 1);
        }
        // 加载状态结束
        this.loading = false;

        // 数据全部加载完成
        if (this.list.length >= 40) {
          this.finished = true;
        }
      }, 500);
    }
  },
  components: {
    hshead,
    "van-tabs": Tabs,
    "van-tab": Tab,
    "van-list": List
  }
};
</script>

<style lang="less" scoped>
@import "../assets/less/common.less";
@import "../assets/less/mixin.less";
.order-ul {
  margin-top: 0.5rem;
  .order-li {
    width: 6.7rem;
    background-color: #ffffff;
    box-shadow: 0rem 0.01rem 0.18rem 0rem rgba(129, 135, 148, 0.18);
    border-radius: 0.1rem;
    margin: 0 auto;
    margin-bottom: 0.35rem;
    .top-p {
      height: 0.82rem;
      line-height: 0.82rem;
      font-size: 0.24rem;
      display: flex;
      border-bottom: 1px solid #e5e5e5;
      .top-l {
        font-family: PingFang-SC-Medium;
        font-stretch: normal;
        letter-spacing: 0rem;
        color: #8a9096;
        padding-left: 0.27rem;
        width: (6.7-0.27 * 2)/2rem;
      }
      .top-r {
        color: #00b8f5;
        text-align: right;
        padding-right: 0.27rem;
        width: (6.7-0.27 * 2)/2rem;
      }
    }
    .content-box {
      padding: 0.47rem 0.3rem;
      border-bottom: 1px solid #e5e5e5;
      .content-top {
        display: flex;
        margin-bottom: 0.15rem;
        .left-img {
          padding-right: 0.2rem;
          width: 0.62rem;
          img {
            width: 0.62rem;
            height: 0.62rem;
          }
        }
        .center-p {
          width: 4.6rem;
          padding-bottom: 0.4rem;
          .center-p-h1 {
            display: block;
            font-family: PingFangSC-Medium;
            font-size: 0.28rem;
            font-weight: normal;
            font-stretch: normal;
            letter-spacing: 0rem;
            color: #666666;
          }
          .center-p-p {
            height: 0.21rem;
            font-family: PingFangSC-Regular;
            font-size: 0.22rem;
            font-weight: normal;
            font-stretch: normal;
            line-height: 0.4rem;
            letter-spacing: 0rem;
            color: #00bbfb;
          }
        }
        .right-icon {
          flex: 1;
          img {
            width: 0.64rem;
            height: 0.64rem;
            background-color: #ffffff;
          }
        }
      }
      .content-content {
        display: flex;
        .left-p {
          width: 50%;
          font-family: PingFangSC-Medium;
          font-size: 0.36rem;
          font-weight: bold;
          font-stretch: normal;
          line-height: 0.4rem;
          letter-spacing: 0rem;
          color: #222222;
          span {
            font-size: 0.28rem;
          }
        }
        .right-p {
          flex: 1;
          text-align: right;
          font-family: PingFangSC-Medium;
          font-size: 0.28rem;
          font-weight: bold;
          font-stretch: normal;
          line-height: 0.4rem;
          letter-spacing: 0rem;
          color: #ff3087;
        }
        margin-bottom: 0.4rem;
      }
      .content-iconp {
        font-family: PingFangSC-Regular;
        font-size: 0.24rem;
        font-weight: normal;
        font-stretch: normal;
        line-height: 0.24rem;
        letter-spacing: 0rem;
        color: #8a9096;
        padding-left: 0.5rem;
        margin-top: 0.2rem;
        word-break: break-all;
        &.iconp1 {
          background: url(../assets/images/order/1.png) left center no-repeat;
          background-size: 0.2rem 0.22rem;
        }
        &.iconp2 {
          background: url(../assets/images/order/2.png) left center no-repeat;
          background-size: 0.19rem 0.24rem;
        }
        &.iconp3 {
          background: url(../assets/images/order/3.png) left center no-repeat;
          background-size: 0.22rem 0.21rem;
        }
      }
    }
    .order-li-bt {
      height: 1.17rem;
      display: flex;
      align-items: center;
      justify-content: flex-end;
      .this-btn {
        width: 1.7rem;
        height: 0.6rem;
        border-radius: 0.3rem;
        border: solid 0.01rem #00b8f5;
        font-size: 0.24rem;
        font-weight: normal;
        font-stretch: normal;
        line-height: 0.6rem;
        letter-spacing: 0rem;
        color: #00b8f5;
        text-align: center;
        display: block;
        margin: 0 0.3rem;
        &.btn1 {
        }
        &.btn2 {
          background-color: #00b8f5;
          color: #fff;
        }
      }
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/components/order.vue